import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})

export class AuthLayoutRoutes {

  constructor(private router: Router) {

  }

  navigateToLogin() {
    this.router.navigate(["/login"]);
  }

  navigateToPasswordResetsent(){
    this.router.navigate(['/resetpasswordsent']);
  }

  navigateToPasswordResetSuccessful(){
    this.router.navigate(['/passwordresetsuccess']);
  }

}